<div class="p-6 general-simple-box flex flex-col gap-6">
  <mat-tab-group
    [selectedIndex]="selectedTabIndex"
    (selectedIndexChange)="onTabChange($event)"
    mat-stretch-tabs="false"
    mat-align-tabs="center"
  >
    <mat-tab [label]="'financialStatement.tabs.profitAndLoss' | translate">
      <ng-container *ngTemplateOutlet="financialTable"></ng-container>
    </mat-tab>

    <mat-tab [label]="'financialStatement.tabs.comparativeBalance' | translate">
      <ng-container *ngTemplateOutlet="financialTable"></ng-container>
    </mat-tab>

    <mat-tab [label]="'financialStatement.tabs.indicators' | translate">
      <ng-container *ngTemplateOutlet="financialTable"></ng-container>
    </mat-tab>

    <mat-tab [label]="'financialStatement.tabs.cashFlow' | translate">
      <ng-container *ngTemplateOutlet="financialTable"></ng-container>
    </mat-tab>

    <mat-tab [label]="'financialStatement.tabs.taxStatus' | translate">
      <ng-container *ngTemplateOutlet="financialTable"></ng-container>
    </mat-tab>

    <mat-tab [label]="'financialStatement.tabs.backStatement' | translate">
      <ng-container *ngTemplateOutlet="financialTable"></ng-container>
    </mat-tab>

    @if (hasSelectedPeriods) {
      <mat-tab [label]="'financialStatement.tabs.prints' | translate">
        <div class="flex justify-end p-4 no-print">
          <button mat-button class="button-general" (click)="printReport()">
            <mat-icon>print</mat-icon> {{ 'financialStatement.buttons.printReport' | translate }}
          </button>
        </div>

        <div class="print-container">
          @for (chunk of printPeriodChunks; track $index) {
            <div class="print-page">
              <table class="w-full text-left border-collapse border border-black print-table mb-8">
                <thead>
                  <tr>
                    <th
                      colspan="100%"
                      class="text-center p-2 bg-gray-100 border border-black uppercase text-lg"
                    >
                      <strong
                        >{{
                          'financialStatement.titles.financialStatementAndComparativeBalance'
                            | translate
                        }}
                        <br />
                        <span class="text-sm">{{
                          'financialStatement.titles.currencyType' | translate
                        }}</span></strong
                      >
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" class="text-right p-2 border border-black uppercase text-sm">
                      {{ 'financialStatement.titles.applicantName' | translate }}
                    </th>
                    <th
                      [attr.colspan]="chunk.length * 2"
                      class="p-2 border border-black bg-black text-white font-bold uppercase text-sm"
                    >
                      {{ applicantName }}
                    </th>
                  </tr>

                  <tr>
                    <th colspan="2" class="text-right p-2 border border-black text-sm">
                      {{ 'financialStatement.titles.periodNumber' | translate }}
                    </th>
                    @for (p of chunk; track p.periodNumber) {
                      <th colspan="2" class="text-center p-2 border border-black bg-gray-300">
                        {{ p.periodNumber }}
                      </th>
                    }
                  </tr>
                  <tr>
                    <th colspan="2" class="text-right p-2 border border-black text-sm">
                      {{ 'financialStatement.titles.internalOrExternal' | translate }}
                    </th>
                    @for (p of chunk; track p.periodNumber) {
                      <th colspan="2" class="text-center p-2 border border-black bg-gray-300">
                        {{ p.type }}
                      </th>
                    }
                  </tr>
                  <tr>
                    <th colspan="2" class="text-right p-2 border border-black text-sm">
                      {{ 'financialStatement.titles.nameOfOffice' | translate }}
                    </th>
                    @for (p of chunk; track p.periodNumber) {
                      <th colspan="2" class="text-center p-2 border border-black bg-gray-300">
                        {{ p.dispatch }}
                      </th>
                    }
                  </tr>
                  <tr>
                    <th colspan="2" class="text-right p-2 border border-black text-sm border-b-2">
                      {{ 'financialStatement.titles.studyDate' | translate }}
                    </th>
                    @for (p of chunk; track p.periodNumber) {
                      <th
                        colspan="2"
                        class="text-center p-2 border border-black bg-gray-300 border-b-2 font-bold"
                      >
                        {{ p.date | date: 'MM-yyyy' }}
                      </th>
                    }
                  </tr>
                </thead>

                <tbody>
                  @for (grupo of agroupConcepts; track grupo.typeEf) {
                    <tr class="bg-gray-100 border-y-2 border-black">
                      <td
                        [attr.colspan]="chunk.length * 2 + 2"
                        class="p-2 font-bold uppercase text-sm text-center"
                      >
                        <u>{{ grupo.typeEf }}</u>
                      </td>
                    </tr>

                    @for (fila of grupo.rows; track fila.conceptName) {
                      <tr>
                        <td
                          colspan="2"
                          class="p-2 border border-black text-sm text-right"
                          [class.font-bold]="fila.isBold"
                        >
                          {{ fila.conceptName }}
                        </td>

                        @for (p of chunk; track p.periodNumber) {
                          @if (fila.periodData[p.periodNumber]; as cellData) {
                            <td
                              class="p-2 border-t border-black text-right text-sm w-24"
                              [class.font-bold]="fila.isBold"
                            >
                              {{ cellData.value | number: '1.2-2' }}
                            </td>
                            <td
                              class="p-2 border-t border-black border-r text-left text-sm w-16"
                              [class.font-bold]="fila.isBold"
                            >
                              @if (cellData.percentaje !== 0) {
                                {{ cellData.percentaje | number: '1.0-0' }}%
                              }
                            </td>
                          } @else {
                            <td class="p-2 border-t border-black text-center text-sm w-24">-</td>
                            <td class="p-2 border-t border-black border-r text-center text-sm w-16">
                              -
                            </td>
                          }
                        }
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>

<app-load-general [load]="loadService"></app-load-general>

<ng-template #financialTable>
  <div
    class="flex flex-col md:flex-row justify-between items-center bg-(--brand-azul-fondo-general) py-4 px-6 min-w-75 rounded-xl"
  >
    <div class="flex flex-col">
      <span class="text-general-subtitle text-(--color-text-gray) uppercase"
        >{{ 'financialStatement.titles.applicantName' | translate }}:</span
      >
      <span class="text-general-title text-(--color-text-primary)">{{ applicantName }}</span>
      <span class="text-xs text-(--color-text-gray) mt-1"
        >({{ 'financialStatement.titles.currencyType' | translate }})</span
      >
    </div>

    <div class="flex gap-4 mt-4 md:mt-0">
      <button mat-button class="button-general-border" (click)="addPeriod()">
        {{ 'financialStatement.buttons.addPeriod' | translate }}
      </button>
      <button mat-button class="button-general" (click)="updateAllValues()">
        {{ 'financialStatement.buttons.updateAllValues' | translate }}
      </button>
    </div>
  </div>

  <div class="scrol-general-x w-full overflow-x-auto pb-4">
    <table class="w-full text-left border-collapse min-w-max">
      <thead>
        <tr>
          <th class="align-bottom w-auto min-w-62.5 max-w-md">
            <div
              class="flex flex-col gap-4 font-semibold text-(--color-text-gray) p-3 pb-4 text-sm"
            >
              <div class="h-10 flex items-center">
                {{ 'financialStatement.titles.periodNumber' | translate }}
              </div>
              @if (selectedTabIndex !== 5) {
                <div class="h-12 flex items-center">
                  {{ 'financialStatement.titles.internalOrExternal' | translate }}
                </div>
                <div class="h-12 flex items-center">
                  {{ 'financialStatement.titles.nameOfOffice' | translate }}
                </div>
              } @else {
                <div class="h-12 flex items-center">
                  {{ 'financialStatement.titles.bankName' | translate }}
                </div>
                <div class="h-12 flex items-center">
                  {{ 'financialStatement.titles.accountNumber' | translate }}
                </div>
                <div class="h-12 flex items-center">
                  {{ 'financialStatement.titles.representedMonth' | translate }}
                </div>
              }
              <div class="h-12 flex items-center">
                {{ 'financialStatement.titles.studyDate' | translate }}
              </div>
            </div>
          </th>

          <!-- Columnas 2 a N: Tarjetas de Periodos -->
          @for (period of periods; track period.periodNumber) {
            <th class="align-bottom font-normal">
              <div
                class="shrink-0! flex flex-col gap-4 p-4 mb-2 min-w-50 bg-white border border-(--comp-input-normal-border) rounded-xl general-shadow mx-auto"
              >
                <!-- Fila 1: Checkbox y Delete -->
                <div
                  class="h-10 flex justify-between items-center border-b border-(--comp-input-normal-border)"
                >
                  <mat-checkbox
                    [checked]="period.selected"
                    (change)="updateHeaderData(7, period.periodNumber, $event.checked)"
                  >
                    {{ period.periodNumber }}
                  </mat-checkbox>
                  <button
                    mat-icon-button
                    color="warn"
                    (click)="deletePeriod(period.periodNumber)"
                    matTooltip="{{ 'financialStatement.buttons.deletePeriod' | translate }}"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                @if (selectedTabIndex !== 5) {
                  <!-- Fila 2: Tipo -->
                  <div class="h-12">
                    <app-input-general
                      [formControlGeneral]="getControl(period.periodNumber, 'type')"
                      [placeholder]="'financialStatement.inputs.type' | translate"
                      (focusout)="updateHeaderData(1, period.periodNumber)"
                    ></app-input-general>
                  </div>

                  <!-- Fila 3: Despacho -->
                  <div class="h-12">
                    <app-input-general
                      [formControlGeneral]="getControl(period.periodNumber, 'dispatch')"
                      [placeholder]="'financialStatement.inputs.dispatch' | translate"
                      (focusout)="updateHeaderData(2, period.periodNumber)"
                    ></app-input-general>
                  </div>
                } @else {
                  <!-- Fila 2: Nombre del banco -->
                  <div class="h-12">
                    <app-input-general
                      [formControlGeneral]="getControl(period.periodNumber, 'bank')"
                      [placeholder]="'financialStatement.inputs.bank' | translate"
                      (focusout)="updateHeaderData(4, period.periodNumber)"
                    ></app-input-general>
                  </div>

                  <!-- Fila 3: Numero de cuenta -->
                  <div class="h-12">
                    <app-input-general
                      [formControlGeneral]="getControl(period.periodNumber, 'accountNumber')"
                      [placeholder]="'financialStatement.inputs.accountNumber' | translate"
                      (focusout)="updateHeaderData(5, period.periodNumber)"
                    ></app-input-general>
                  </div>

                  <!-- Fila 4: Mes que representa -->
                  <div class="h-12">
                    <app-input-general
                      [formControlGeneral]="getControl(period.periodNumber, 'month')"
                      [placeholder]="'financialStatement.inputs.month' | translate"
                      (focusout)="updateHeaderData(6, period.periodNumber)"
                    ></app-input-general>
                  </div>
                }
                <!-- Fila 4: Fecha -->
                <div class="h-12">
                  <app-input-general
                    [formControlGeneral]="getControl(period.periodNumber, 'date')"
                    [type]="'financialStatement.inputs.date' | translate"
                    (focusout)="updateHeaderData(3, period.periodNumber)"
                  ></app-input-general>
                </div>
                <div></div>
              </div>
            </th>
          }
        </tr>
      </thead>

      <!-- BODY: Datos de los conceptos -->
      <tbody>
        <!-- Pequeño espaciador para separar visualmente las tarjetas de las filas -->
        <tr>
          <td [attr.colspan]="periods.length + 1" class="h-4"></td>
        </tr>

        @for (grupo of agroupConcepts; track grupo.typeEf) {
          <!-- Título del Grupo -->
          <tr class="bg-(--brand-azul-light)">
            <td
              [attr.colspan]="periods.length + 1"
              class="p-3 font-bold text-(--color-text-primary) uppercase text-sm"
            >
              {{ grupo.typeEf }}
            </td>
          </tr>

          <!-- Filas de Conceptos -->
          @for (fila of grupo.rows; track fila.conceptName) {
            <tr
              class="border-b border-(--comp-input-normal-border) hover:bg-(--brand-gray-light) transition-colors text-sm"
            >
              <!-- Nombre del Concepto -->
              <td
                class="p-3 text-(--color-text-body) font-medium max-w-md truncate"
                [class.font-bold]="fila.isBold"
                [class.font-medium]="!fila.isBold"
              >
                {{ fila.conceptName }}
              </td>

              <!-- Inputs por Periodo -->
              @for (period of periods; track period.periodNumber) {
                <td class="p-3 align-middle text-right w-48">
                  @if (fila.periodData[period.periodNumber]; as cellData) {
                    @if (fila.valueType === 'CALCULADO') {
                      <div class="flex items-center justify-end h-10 w-full pr-2">
                        <span class="font-bold text-(--color-text-body)">
                          {{ cellData.value | number: '1.2-2' }}
                        </span>
                        @if (cellData.percentaje !== 0) {
                          <span class="text-(--color-text-gray) text-xs ml-2 w-8 text-left"
                            >{{ cellData.percentaje }}%</span
                          >
                        }
                      </div>
                    } @else {
                      <div class="flex items-center justify-end gap-2 w-full">
                        <app-input-general
                          class="w-28"
                          [formControlGeneral]="getControlValue(cellData.idEeff)"
                          [type]="'number'"
                          (focusout)="updateValue(cellData.idEeff)"
                        ></app-input-general>

                        @if (cellData.percentaje !== 0) {
                          <span class="text-(--color-text-gray) text-xs w-8 text-left"
                            >{{ cellData.percentaje }}%</span
                          >
                        } @else {
                          <span class="w-8"></span>
                        }
                      </div>
                    }
                  } @else {
                    <div class="h-10 flex items-center justify-end text-gray-300 pr-4">-</div>
                  }
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</ng-template>
